module.exports = __webpack_public_path__ + "img/index_banner.17ce3c1b.png";